import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'redux-persist';
import SecureLS from 'secure-ls';
import RefreshMiddleware from './refreshMiddleware';

// import reducers
import AuthReducer from '../features/Auth/AuthSlice';
import LoaderReducer from '../features/Loader/LoaderSlice';
import ConfigReducer from '../features/Config/ConfigSlice';
import VendorReducer from '../features/Vendor/VendorSlice';
import OrderReducer from '../features/Order/OrderSlice';
import UserReducer from '../features/User/UserSlice';
import GeneralReducer from '../features/General/GeneralSlice';
import SkuReducer from '../features/Sku/SkuSlice';
import SocketReducer from '../features/Socket/SocketSlice';
import ReceiptReducer from '../features/Receipt/ReceiptSlice';

const ls = new SecureLS({
  isCompression: false,
  key: 'emma-vp-ls',
  encryptionSecret: '0e0x0d3a1a8i6e58f'
});

const persistConfig = {
  key: 'emma-vp',
  storage: {
    getItem: (key) => Promise.resolve(ls.get(key)),
    setItem: (key, value) => Promise.resolve(ls.set(key, value)),
    removeItem: (key) => Promise.resolve(ls.remove(key))
  }
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    auth: AuthReducer,
    loader: LoaderReducer,
    config: ConfigReducer,
    vendor: VendorReducer,
    order: OrderReducer,
    user: UserReducer,
    general: GeneralReducer,
    sku: SkuReducer,
    socket: SocketReducer,
    receipt: ReceiptReducer
  })
);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    }).concat(RefreshMiddleware.middleware)
});

export const persistor = persistStore(store);
